import api from './index'

let exports = {};

// ---------------- 财务核算模型 -------------------
// 根据机构id获取财务核算模型
exports.getFiscalAcntModelDefByComId = function (params, callback) {
    api.get('/finac2/fiscal/acnt/model/def/get/by/comId')
        .params(params)
        .done(callback)
        .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/finac2.js
// module id = 548
// module chunks = 0